import React from 'react'
import Button from '@material-ui/core/Button'
import { Translate } from '../../utils/Translate'
import { Typography } from '@material-ui/core';
import { linkParser } from '../../utils/linkParser'
import { useNavigate } from 'react-router';
var config = require("../../assets/config.json");

const SubscriptionComponent = (props)=> {
        const navigate = useNavigate();
        return (
            <div>
                <div className="">
                    <Typography variant="h1" className="market-tag-h1">
                        {Translate({ id: "homePage.MembersAccessTitle" })}
                    </Typography>
                    <Typography variant="h3" className="subText ">
                        {linkParser("homePage.MembersAccessSubTitle")}

                    </Typography>
                    {props.isAuthenticated ? "" :
                        <Button variant="contained" color="secondary" className="m-t-15 m-t-xs-15 btn-default hero-button"
                            onClick={() => {
                                if (config.msalSsoSupport) {
                                    props.AuthenticateThirdPartyUser();
                                } else {
                                    navigate("/signup");
                                }
                            }}>
                            <Typography variant="button">
                                {Translate({ id: "Subscription.GetAccess" })}
                            </Typography>
                        </Button>
                    }
                </div>
            </div>
        )
}

export default SubscriptionComponent;
